import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './theme.css'
import './index.css'
import 'katex/dist/katex.min.css'
import App from './App.tsx'
import * as Sentry from "@sentry/react";
import { initViewportHeightVar } from '@sharpana/shared/utils/viewportHeight';


Sentry.init({
  dsn: "https://3d78c8ac400e29d4043317739e8e344d@o4508525782040576.ingest.us.sentry.io/4508525839122432",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  // app.sharpana.io is the coaching product's live host.  The previous
  // pattern (app.coaching.*) matched no hostname that exists, so tracing
  // was never propagated in production at all.
  tracePropagationTargets: ["localhost", /^https:\/\/app\.sharpana\.io/, /^https:\/\/app\.zairai\.ai/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.VITE_ENV_NAME,
});

initViewportHeightVar();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
